import React from 'react';

const PnlConfigSystemFormModal = React.lazy(() => import('../components/FormModal'));
const pnlConfigSystemModalRegistry = {
    personalize_pnlConfigSystemId: PnlConfigSystemFormModal
};
export default pnlConfigSystemModalRegistry;
